import swal from 'sweetalert2'

export default {

  install: (Vue) => {

    // sweetalert2 的设置默认配置的方法

    swal.setDefaults({


      showCancelButton: false,//是否显示取消按钮
      allowOutsideClick:false,//点击模态框是否关闭

      confirmButtonColor: '#F56C6C',//确认按钮颜色

      cancelButtonColor: '#fff',//取消按钮颜色
      customClass: "sweetAlert"   
    })

    // 添加全局方法

    Vue.swal = swal

    // 添加实例方法

    Vue.prototype.$swal = swal

  }

}


// WEBPACK FOOTER //
// ./src/plugins/vue-sweetalert2.js